import { useCallback, useEffect, useRef } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

/** One router entry per opening; browser and native Back consume that entry. */
function useMembersRouteOverlay(stateKey) {
  const location = useLocation()
  const navigate = useNavigate()
  const open = location.state?.[stateKey] === true
  const pending = useRef(false)
  useEffect(() => { pending.current = false }, [location.key])
  const setOpen = useCallback(next => {
    if (pending.current || next === open) return
    pending.current = true
    if (next) {
      const state = { ...location.state }
      if (stateKey === 'membersBookingDetails') {
        delete state.viewBookingId
        delete state.viewBookingType
        // A success-page intent is consumed once; Back returns to plain Home.
        if (location.state?.viewBookingId) navigate(`${location.pathname}${location.search}${location.hash}`, { replace: true, state, preventScrollReset: true })
      }
      navigate(`${location.pathname}${location.search}${location.hash}`, {
        state: { ...state, [stateKey]: true }, preventScrollReset: true,
      })
    }
    else navigate(-1)
  }, [open, location, navigate, stateKey])
  useMembersNativeBack(open, () => setOpen(false))
  return [open, setOpen]
}

/** Only the active conversation owns a native Back listener. */
export function useMembersNativeBack(enabled, onBack) {
  const handler = useRef(onBack)
  handler.current = onBack
  useEffect(() => {
    if (!enabled || !globalThis.Capacitor?.isNativePlatform?.()) return undefined
    let disposed = false, subscription
    import('@capacitor/app').then(({ App }) => App.addListener('backButton', () => handler.current()))
      .then(handle => { if (disposed) handle.remove(); else subscription = handle })
      .catch(() => {})
    return () => { disposed = true; subscription?.remove() }
  }, [enabled])
}

export function useMembersConversationOverlay() {
  return useMembersRouteOverlay('membersConversation')
}

export function useMembersBookingOverlay() {
  return useMembersRouteOverlay('membersBookingDetails')
}
